export const getComments = state => state.comments;
